import { isDayjs } from 'dayjs';

import MetadataTypeDefinition from '@/shared/types/metadata/metadataTypeDefinition.type';

import metadataFieldsConfig from './metadataFieldsConfig';

type Args = {
  metadataType: string;
  metadataKey: string;
  fieldLabel: string;
  required: boolean;
  value?: unknown;
  fieldPlaceholder?: string;
  fieldHelperText?: string;
  isVisible?: boolean;
};

const generateFormFieldByMetaType = ({
  metadataType,
  metadataKey,
  fieldLabel,
  required,
  value,
  fieldPlaceholder = '',
  fieldHelperText = '',
  isVisible,
}: Args) => {
  const config =
    metadataFieldsConfig[metadataType as keyof MetadataTypeDefinition];

  if (!config) return [];

  return config.map((fieldConfig) => {
    const updatedFieldProps = { ...fieldConfig.field_props };

    Object.entries(updatedFieldProps).forEach(([key, fieldValue]) => {
      switch (fieldValue) {
        case 'fieldName':
          updatedFieldProps[key] = metadataKey;
          break;
        case 'fieldLabel':
          updatedFieldProps[key] = fieldLabel;
          break;
        case 'fieldPlaceholder':
          updatedFieldProps[key] = fieldPlaceholder;
          break;
        case 'fieldHelperText':
          updatedFieldProps[key] = fieldHelperText;
          break;
        case 'required':
          updatedFieldProps[key] = required;
          break;
        case 'value':
          if (typeof value === 'object' && !isDayjs(value)) {
            const suffix = (updatedFieldProps.name as string).split(':')[1];
            updatedFieldProps[key] = (value as Record<string, unknown>)[suffix];
          } else {
            updatedFieldProps[key] = value;
          }
          break;
        default:
          if (
            typeof fieldValue === 'string' &&
            fieldValue.startsWith('fieldName:')
          ) {
            const [, suffix] = fieldValue.split(':');
            updatedFieldProps[key] = `${metadataKey}:${suffix}`;
          }
      }
    });

    return {
      ...fieldConfig,
      isVisible,
      field_props: updatedFieldProps,
    };
  });
};

export default generateFormFieldByMetaType;
